export default "__VITE_ASSET__CoflavJf__"